export const DEFAULT_ERROR_MESSAGE = 'Something went wrong! Please try again.';

export const TRANSCRIPT_EDIT_TOAST_ID = 'transcript-edit';

export const TRANSCRIPT_EDIT_TOAST_AUTOCLOSE_MILLIS = 3500;
export const SUCCESS_TOAST_AUTO_CLOSE_MILLIS = 3500;
